import { Components, Theme } from '@mui/material';

export const drawerOverrides: Components<Theme>['MuiDrawer'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      width: '100%',
      backgroundColor: theme.palette.background.contrast,
      backgroundImage: 'none',
    }),
  },
};
